import { render, staticRenderFns } from "./Comp23t2.vue?vue&type=template&id=42b9f20b&scoped=true&"
import script from "./Comp23t2.vue?vue&type=script&lang=js&"
export * from "./Comp23t2.vue?vue&type=script&lang=js&"
import style0 from "./Comp23t2.vue?vue&type=style&index=0&id=42b9f20b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b9f20b",
  null
  
)

export default component.exports